module.exports = __webpack_public_path__ + "img/brands-barilla-logo.png?4d63fe3077affeb614f381215493b532";